import { Document, Run } from '../../backend';
import { CellView } from '../model/cell-view.model';
import { RowView } from '../model/row-view.model';

export function layoutRows(run: Run): [RowView[], RowView[], RowView[]] {
    const docStr = atob(
        run?.results?.[0]?.artifacts?.find(
            (e) => e.mediaType === 'application/json',
        )?.data,
    );
    const doc: Document = JSON.parse(docStr);

    doc.headerRows.forEach((r: RowView) => {
        r.classList = [
            'cmps-cdk-d-flex',
            'cmps-cdk-align-items-center',
            'cmps-cdk-w-fit-content',
        ].join(' ');
    });

    doc.headerRows?.[0]?.cells.forEach((c: CellView) => {
        const classList =
            c.colGroupId === 0
                ? [
                      'cmps-cdk-d-flex',
                      'cmps-cdk-align-items-center',
                      'cmps-cdk-justify-content-center',
                      'cmps-cdk-bg-color-blue-100',
                      'cmps-cdk-color-white',
                      'cmps-cdk-font-bold',
                      'cmps-cdk-p-0dot25',
                      'cmps-cdk-text-uppercase',
                      'cmps-cdk-letter-spacing-0dot05',
                  ]
                : [
                      'cmps-cdk-d-flex',
                      'cmps-cdk-align-items-center',
                      'cmps-cdk-justify-content-center',
                      'cmps-cdk-bg-color-blue-100',
                      'cmps-cdk-color-white',
                      'cmps-cdk-font-bold',
                      'cmps-cdk-p-0dot25',
                      'cmps-cdk-letter-spacing-0dot05',
                  ];

        c.classList = classList.join(' ');
    });

    doc.headerRows?.[1]?.cells.forEach((c: CellView) => {
        const classList =
            c.colGroupId === 0
                ? [
                      'cmps-cdk-d-flex',
                      'cmps-cdk-align-items-center',
                      'cmps-cdk-justify-content-center',
                      'cmps-cdk-bg-color-blue-100',
                      'cmps-cdk-color-white',
                      'cmps-cdk-font-bold',
                      'cmps-cdk-p-0dot25',
                      'cmps-cdk-text-uppercase',
                      'cmps-cdk-letter-spacing-0dot05',
                  ]
                : [
                      'cmps-cdk-d-flex',
                      'cmps-cdk-align-items-center',
                      'cmps-cdk-justify-content-center',
                      'cmps-cdk-font-bold',
                      'cmps-cdk-p-0dot25',
                      'cmps-cdk-text-uppercase',
                      'cmps-cdk-letter-spacing-0dot05',
                      'cmps-report-bg-color-ukn-101',
                  ];

        c.classList = classList.join(' ');
    });

    doc.bodyRows.forEach((r: RowView, rIndex: number) => {
        r.classList = [
            'cmps-cdk-d-flex',
            'cmps-cdk-align-items-center',
            'cmps-cdk-w-fit-content',
            rIndex % 2 === 0
                ? 'not:hover:cmps-report-bg-color-ukn-107'
                : 'not:hover:cmps-report-bg-color-ukn-101',
            'hover:cmps-report-bg-color-ukn-102',
        ].join(' ');

        r.cells.forEach((c: CellView) => {
            const classList = [
                'cmps-cdk-d-flex',
                'cmps-cdk-align-items-center',
                'cmps-cdk-p-0dot25',
            ];

            if (![0].includes(c.colGroupId) && [30].includes(c.colId)) {
                classList.push('cmps-cdk-justify-content-center');
            }

            if (![0].includes(c.colGroupId) && [10, 20, 40].includes(c.colId)) {
                classList.push('cmps-cdk-justify-content-flex-end');
            }

            c.classList = classList.join(' ');

            if (c.valueType?.toLowerCase()?.trim() === 'double precision') {
                c.valueAsNumber = c.value == null ? null : Number(c.value);
            }
        });
    });

    const allRows = [...doc.headerRows, ...doc.bodyRows];
    allRows.forEach((r: RowView, rIndex) => {
        r.cells.forEach((c, cIndex) => {
            c.width = 100 * c.cellSpan;
            c.height = 25;

            const classList = c.classList.split(' ');
            if (cIndex !== r.cells.length - 1) {
                classList.push(
                    'cmps-cdk-border-r-color-grey-300',
                    'cmps-cdk-border-r-solid',
                    'cmps-cdk-border-r-width-1px',
                );
            }
            if (rIndex !== allRows.length - 1) {
                classList.push(
                    'cmps-cdk-border-b-color-grey-300',
                    'cmps-cdk-border-b-solid',
                    'cmps-cdk-border-b-width-1p',
                );
            }
            c.classList = classList.join(' ');
        });

        r.width = 0;
        r.cells.forEach((c) => {
            r.width += c.width;
        });
    });

    return [
        doc.headerRows as RowView[],
        doc.bodyRows as RowView[],
        allRows as RowView[],
    ];
}
